module.exports = __webpack_public_path__ + "static/media/tendericon02.f7257284.png";